import React from "react";
import { Monitor, HeadphonesIcon } from "lucide-react";
import SiteShell from "../../components/SiteShell";
import SEO from "../../components/SEO";
import { DeptHero, DeptSection, PersonCard, CardGrid } from "./_shared";

/**
 * /team/hr-it — HR & IT department.
 * Ported from client Vite/TSX source; branding scrubbed. Members here
 * do not have photos in the source package — silhouette fallback used.
 */

const itTeam = [
  { name: "Meghala", role: "ERP Specialist" },
  { name: "Baskaran", role: "ICT Business Analyst" },
  { name: "Thiagarajan", role: "CAD Programmer" },
  { name: "Srivasan", role: "IT Specialist" },
];

const supportTeam = [
  { name: "Sara M", role: "Technical Support Representative" },
  { name: "Akila", role: "Customer Service Representative" },
];

export default function HRIT() {
  return (
    <SiteShell>
      <SEO
        title="HR & IT Team — Green Gold Energy"
        description="Meet Green Gold Energy's HR & IT department providing technical support and business solutions."
      />
      <DeptHero
        kicker="HR & IT Department"
        title="People operations and internal systems"
        sub="Internal systems and people operations — the scaffolding that lets 60+ builders ship on schedule across the SPV, factory, R&D bench, and field."
        Icon={Monitor}
      />

      <DeptSection
        Icon={Monitor}
        title="IT Specialists"
        description="ERP, ICT analysis, CAD programming and end-user IT — keeping every desk and every drawing connected."
      >
        <CardGrid minCol={260}>
          {itTeam.map((m) => (
            <PersonCard key={m.name} member={m} variant="compact" />
          ))}
        </CardGrid>
      </DeptSection>

      <DeptSection
        Icon={HeadphonesIcon}
        title="Customer Support"
        description="Technical and customer service front-line for every reseller, installer and buyer."
      >
        <CardGrid minCol={260}>
          {supportTeam.map((m) => (
            <PersonCard key={m.name} member={m} variant="compact" />
          ))}
        </CardGrid>
      </DeptSection>

      <div style={{ height: 60 }} />
    </SiteShell>
  );
}
